import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/services';
import { ServiceRequest } from 'src/models';

export type CreateServiceRequestPayload = {
  patient_first_name: string;
  patient_last_name: string;
  patient_birth_date: string;
  patient_email: string;
  patient_phone: string;
  type_id: number;
  start_time: string;
  performing_practitioner_id: number;
  requesting_practitioner_id?: number;
};

export const useCreateServiceRequest = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['createServiceRequest'],
    mutationFn: (payload: CreateServiceRequestPayload) =>
      api
        .post<ServiceRequest>(`/v3/service_request`, payload)
        .then(({ data }) => data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['serviceRequestList'] });
    },
  });
};
